import { MenuItemModel } from "../models/menu-item";
import { rellenarMenUsuario, rellenarMenuAdmin } from './procedimientos_registros';



export var menuItemDataUser: MenuItemModel[] = [

];

if ( localStorage.getItem('role') === 'ROLE_ADMIN' ) {
    menuItemDataUser =  rellenarMenuAdmin(); 
} else {
    menuItemDataUser =  rellenarMenUsuario(); 
}

export var menuItemDataAdmin: MenuItemModel[] = menuItemDataUser;


